import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-inventory-tile',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './inventory-tile.component.html',
    styleUrl: './inventory-tile.component.scss'
})
export class InventoryTileComponent {
    getStatusClass(stockStatus: string): string {
        switch (stockStatus?.toLowerCase()) {
            case 'good':
                return 'green-bg';

            case 'low':
                return 'yellow-bg';

            case 'critical':
                return 'red-bg';

            default:
                return 'gray-bg';
        }
    }
    @Input() itemName!: string;
    @Input() stock!: string;
    @Input() expirationDate!: string;
    @Input() stockStatus!: string;
}
